import { UUID } from '@finxone-platform/shared/base-types';
import {
  BorderRadiusKeys,
  BorderStyles,
  ButtonSizeOptions,
  ButtonTypes,
  Constants,
  DummyRole,
  NavigationOptionEnum,
  WidgetNames,
  WidgetTitles,
  WorkflowWidgetConfig,
} from '@finxone-platform/shared/sys-config-types';

export const companiesHouseListingWidgetConfig: WorkflowWidgetConfig = {
  widgetTypeConfig: 'new',
  uniqueId: new UUID().toString(),
  name: WidgetNames.COMPANIES_HOUSE_LISTING_WIDGET,
  widgetConfiguration: {
    widgetDisplayName: WidgetTitles.COMPANIES_HOUSE_LISTING_WIDGET,
    widgetConfigDisplayName: WidgetTitles.COMPANIES_HOUSE_LISTING_WIDGET,
    attributes: {
      elementsConfig: [],
      css_config: {
        ...Constants.defaultBaseCssConfig,
        marginTop: 50,
        borderWidthTop: 1,
        borderWidthBottom: 1,
        borderWidthLeft: 1,
        borderWidthRight: 1,
        borderWidthUnit: 'px',
        borderRadiusTopLeft: 6,
        borderRadiusBottomLeft: 6,
        borderRadiusTopRight: 6,
        borderRadiusBottomRight: 6,
        borderStyle: BorderStyles.SOLID,
        borderClass: BorderRadiusKeys.NONE,
      },
      widgetProperties: {
        textContent: '',
        listItemTemplate: `<div class="p-4 main-bg-color rad-1 w-full h-full border mb-3" style="border-color: var(--color-border-color);">
  <div class="is-space-between">
    <div>
      <div class="font-weight-bold">{{company.companyName}}</div>
      <div class="typog-sm">{{company.companyNumber}}</div>
      <div class="typog-sm">{{company.dateOfCreation}}</div>
    </div>
    <span class="d-flex">{{{ svgIcon 'arrow-right' '32px' '32px' }}}</span>
  </div>
</div>`,
        noResultsTemplate: '<div class="p-4 text-center">No companies found</div>',
        fetchingTemplate: '<div class="p-4 text-center">Searching...</div>',
        appBuilderState: '',
        outerCss: 'height: 60vh;',
      },
    },
    isRemovable: true,
  },
  gridPosition: undefined,
  widgetIconPath: 'listing',
};

export const companiesHouseDirectorSelectionWidgetConfig: WorkflowWidgetConfig = {
  widgetTypeConfig: 'new',
  uniqueId: new UUID().toString(),
  name: WidgetNames.COMPANIES_HOUSE_DIRECTOR_SELECTION_WIDGET,
  widgetConfiguration: {
    widgetDisplayName: WidgetTitles.COMPANIES_HOUSE_DIRECTOR_SELECTION_WIDGET,
    widgetConfigDisplayName: WidgetTitles.COMPANIES_HOUSE_DIRECTOR_SELECTION_WIDGET,
    attributes: {
      elementsConfig: [],
      css_config: {
        ...Constants.defaultBaseCssConfig,
        marginTop: 50,
        borderWidthTop: 1,
        borderWidthBottom: 1,
        borderWidthLeft: 1,
        borderWidthRight: 1,
        borderWidthUnit: 'px',
        borderRadiusTopLeft: 6,
        borderRadiusBottomLeft: 6,
        borderRadiusTopRight: 6,
        borderRadiusBottomRight: 6,
        borderStyle: BorderStyles.SOLID,
        borderClass: BorderRadiusKeys.NONE,
      },
      widgetProperties: {
        textContent: '',
        targetFormId: '',
        noneOfTheAboveLabel: 'None of the above / Other',
        listItemTemplate: `<div class="p-4 main-bg-color rad-1 w-full h-full border mb-3" style="border-color: var(--color-border-color);">
  <div class="is-space-between">
    <div>
      <div class="font-weight-bold">{{#if officer}}{{officer.name}}{{else}}{{label}}{{/if}}</div>
      <div class="typog-sm">{{officer.officerRole}}</div>
    </div>
    <span class="d-flex">{{{ svgIcon 'arrow-right' '32px' '32px' }}}</span>
  </div>
</div>`,
        noResultsTemplate: '<div class="p-4 text-center">No officers found</div>',
        outerCss: 'height: 60vh;',
      },
    },
    isRemovable: true,
  },
  gridPosition: undefined,
  widgetIconPath: 'listing',
};

export const companiesHouseSearchWidgetConfig: WorkflowWidgetConfig = {
  widgetTypeConfig: 'new',
  uniqueId: new UUID().toString(),
  name: WidgetNames.COMPANIES_HOUSE_SEARCH_WIDGET,
  widgetConfiguration: {
    widgetDisplayName: WidgetTitles.COMPANIES_HOUSE_SEARCH_WIDGET,
    widgetConfigDisplayName: WidgetTitles.COMPANIES_HOUSE_SEARCH_WIDGET,
    nestedWidgets: {
      searchButton: {
        name: WidgetNames.COMPANIES_HOUSE_WIDGET_NESTED_SEARCH_BUTTON,
        widgetConfigDisplayName: 'Search Button',
        isRemovable: true,
        attributes: {
          elementsConfig: [],
          zone: '',
          role: DummyRole.EMPTY_ROLE,
          pageIndex: 0,
          pageUrl: '',
          pageId: '',
          navigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
          css_config: {
            ...Constants.defaultBaseCssConfig,
            color: 'var(--color-on-primary)',
            backGroundColor: 'var(--color-primary)',
            borderColor: 'transparent',
            borderStyle: 'solid',
            borderWidth: 0,
            borderRadiusTopLeft: 8,
            borderRadiusTopRight: 8,
            borderRadiusBottomLeft: 8,
            borderRadiusBottomRight: 8,
            textFont: 'var(--font-family)',
            fontSize: 16,
            paddingTop: 12,
            paddingLeft: 24,
            paddingRight: 24,
            paddingBottom: 12,
            paddingUnit: 'px',
            marginTop: 0,
            marginLeft: 0,
            marginRight: 0,
            marginBottom: 0,
            marginUnit: 'px',
          },
          widgetProperties: {
            textContent: 'Search',
            globalStyling: true,
            globalStylingClass: `${ButtonTypes.PRIMARY} ${ButtonSizeOptions.FULL_WIDTH}`,
            showButtonStyleContent: true,
          },
        },
      },
    },
    attributes: {
      elementsConfig: [],
      css_config: {
        ...Constants.defaultBaseCssConfig,
        color: 'var(--color-on-surface)',
        backGroundColor: 'transparent',
        borderColor: 'transparent',
        borderStyle: 'solid',
        borderWidth: 0,
        textFont: 'var(--font-family)',
        fontSize: 16,
        paddingTop: 10,
        paddingLeft: 10,
        paddingRight: 10,
        paddingBottom: 10,
        paddingUnit: 'px',
      },
      widgetProperties: {
        textContent: '',
        searchMode: 'business-number-only',
        additionalSearchCriteria: [],
        separatorLabel: '<div class="text-center">Or</div>',
        businessNumberLabel: 'Business number',
        companyNameLabel: 'Company name',
        locationLabel: 'Location',
      },
    },
    isRemovable: true,
  },
  gridPosition: undefined,
  widgetIconPath: 'form-widget',
};
